import React from 'react';

import { Project } from '../../../types/entities';
import i18n from '../../../utils/i18n/i18n';

import { SidebarMenuItemLink } from '../sidebar-menu-item-link/sidebar-menu-item-link';
import { SidebarMenuItem } from '../sidebar.types';

import { SidebarHeader } from '@wix/design-system';

interface SidebarOrganizationLevelMenuProps {
  organizationLevelMenuItems: SidebarMenuItem[];
  selectedMenuItemId: string;
  project: Project;
}

export const SidebarOrganizationLevelMenu = ({
  organizationLevelMenuItems,
  selectedMenuItemId,
}: SidebarOrganizationLevelMenuProps) => (
  <>
    <SidebarHeader>{i18n.t('sidebar.organization-level.title')}</SidebarHeader>

    {organizationLevelMenuItems.map((menuItem) => (
      <SidebarMenuItemLink
        menuItem={menuItem}
        key={menuItem.id}
        isActive={menuItem.id === selectedMenuItemId}
      />
    ))}
  </>
);
